<div class="flex flex-col gap-6 p-4">
  <app-payment-panel></app-payment-panel>
  <!-- <app-cash-details></app-cash-details> -->
</div>
